module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZD0iTTQ2My42NjMgNDgwTC4wNSAxLjAwMyAwIDQ3OS43NDdsNDYzLjY2My4yNTN6TTE3Ni4zMzcgMEw2MzkuOTUgNDc4Ljk5NyA2NDAgLjI1MyAxNzYuMzM3IDB6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNlMDAwMDAiLz4KICA8cGF0aCBkPSJNMjcuNzQuMjNoMTE4LjU5N2w0NjguMTc2IDQ3OS4zMTVoLTEyMi4zNUwyNy43MzguMjI5eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/tt.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/tt.svg
// module chunks = 0